export const includes = (filterStr?: string, value?: string) => {
    if (filterStr == null || filterStr === '') {
        return true;
    }

    if (value == null) {
        return false;
    }
    return value.toLowerCase().includes(filterStr.trim().toLowerCase());
};

export const startsWith = (filterStr?: string, value?: string) => {
    if (filterStr == null || filterStr === '') {
        return true;
    }

    if (value == null) {
        return false;
    }

    return !filterStr || value.toLowerCase().startsWith(filterStr.trim().toLowerCase());
};

export function validateEmail(email: string | undefined | null) {
    if (email == null) {
        return false;
    }

    const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

/**
 * Attempts to convert the supplied value to a lower case string.
 * If value is null/undefined, then null/undefined will be returned.
 * If value is not a string, then the same value will be returned.
 * If the value is a string, a lower case string will be returned.
 */
export function toLowerCase(value: string | undefined | null) {
    if (value === undefined) {
        return undefined;
    }

    if (value === null) {
        return null;
    }

    if (typeof value === 'string') {
        return value.toLowerCase();
    }

    return value;
}
